import type { NotificationRepository } from '@/domain/notifications/repositories/notification_repository'

/** Placeholder until admin notification list API is wired. */
export class NotificationRepositoryImpl implements NotificationRepository {
  async delete(_id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 500))
  }
}

export const notificationRepository = new NotificationRepositoryImpl()
